// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const whismur: PokeData = {
  "id": 293,
  "name": "whismur",
  "height": 6,
  "weight": 163,
  "base_experience": 48,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "pound",
    "stomp",
    "roar",
    "supersonic",
    "screech",
    "rest",
    "sleep-talk",
    "uproar",
    "hyper-voice",
    "astonish",
    "howl",
    "synchronoise",
    "echoed-voice"
  ],
  "moves": [
    "supersonic",
    "hyper-voice",
    "scary-face",
    "tri-attack",
    "tackle",
    "headbutt",
    "body-slam",
    "purification",
    "quick-attack",
    "scratch",
    "splash",
    "growl",
    "leer"
  ],
  "evolution_chain": {
    "id": 145,
    "item": null,
    "species": [
      {
        "name": "whismur",
        "order": 319,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "loudred",
        "order": 320,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 293,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "exploud",
        "order": 321,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 294,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 43.5,
    "speed": 28,
    "ability_power": 51
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
